﻿import React from 'react';

import { Col, Container, Row } from 'react-bootstrap';
import { ReportComponent } from 'apis/ReportApi';
import { FormattedMessage } from 'react-intl';

import 'pages/reports/components/ChartInfoBox/styles/chart-info-box.scss';

interface ChartInfoBoxProps {
	component: ReportComponent;
	index: number;
	isSubReport?: boolean;
	loading: boolean;
}

export function ChartInfoBox({ component, index, isSubReport = false, loading }: ChartInfoBoxProps) {

    return (
        <Col
            className={`component-wrapper__col print-only-column ${isSubReport && 'rounded-0'}`}
            key={`${component.ComponentId}-${index}`}
            lg={isSubReport ? 12 : component.WidthLg}
            md={isSubReport ? 12 : component.WidthMd}
            sm={isSubReport ? 12 : component.WidthSm}
            xl={isSubReport ? 12 : component.WidthXl}
            xxl={component.WidthXl}
        >
            {!loading ? (
                <>
                    <Container className="chart-info-box gy-5">
                        <h6 className="text-left mb-2 chart-info-box__title">
                            {component.Title}
                        </h6>
                        <Row className="parent">
                            {component.Results?.SeriesList.length === 0 && (
                            <div className="text-center">
                                <FormattedMessage defaultMessage="No Results Found" id="no_results_found.f1d71249" />
                            </div>
                            )}

                            {component.Results?.SeriesList.map(dataList => dataList.Data.map((item, index) => (
                                <Col className="chart-info-box__tile rounded child" key={index}>
                                    <Row className="d-flex justify-content-center mt-2">
                                        <h5 style={{ fontStyle: 'normal' }}>
                                            <b>
                                                {item.Title}
                                            </b>
                                        </h5>
                                    </Row>
                                    <Row className="d-flex justify-content-center mb-2">
                                        <h6>
                                            {item.Share}
                                        </h6>
                                    </Row>
                                </Col>
                            )))}
                        </Row>
                    </Container>
                </>
            ) : (
                <Container>
                    <Row className="skeleton skeleton-topProduct d-flex flex-column p-3">
                        <Col className="d-flex justify-content-center gray p-2"></Col>
                        <Col className="d-flex justify-content-center gray p-3 mt-2"></Col>
                    </Row>
                    <Row className="skeleton skeleton-topProduct d-flex flex-column p-3">
                        <Col className="d-flex justify-content-center gray p-2"></Col>
                        <Col className="d-flex justify-content-center gray p-3 mt-2"></Col>
                    </Row>
                    <Row className="skeleton skeleton-topProduct d-flex flex-column p-3">
                        <Col className="d-flex justify-content-center gray p-2"></Col>
                        <Col className="d-flex justify-content-center gray p-3 mt-2"></Col>
                    </Row>
                </Container>
            )}
        </Col>
    );

}
